<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-service size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Service</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(category)="data">
                <span>{{ data.item.category.name }}</span>
                <span v-if="data.item.category.system_key && data.item.category.system_key.startsWith('psychology_')" class="badge bg-soft-success text-success ms-1">Psychology</span>
                <span v-else-if="data.item.category.system_key === 'system_services'" class="badge bg-soft-primary text-primary ms-1">System</span>
              </template>
              <template #cell(name)="data">
                <span>{{ data.item.name }}</span>
                <span v-if="data.item.is_psychology_service" class="badge bg-soft-success text-success ms-1">Psychology</span>
                <span v-else-if="data.item.is_system == 1" class="badge bg-soft-primary text-primary ms-1">System</span>
              </template>
              <template #cell(addedby)="data">
                {{ data.item.addedby }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.category.id,data.item.name,data.item.costprice,data.item.serviceprice,data.item.system_key,data.item.is_system )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
              <div class="total-payments">
                  <strong>Total CostPrice:</strong> {{ commas(totalCostprice) }}
                  <span class="horizontal-separator">  </span>
                  <strong>Total ServicePrice:</strong> {{ commas(totalServiceprice) }}
                  
                </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-service" centered title="New Service" title-class="font-18" hide-footer>
        <form @submit.prevent="addService">
            <div class="form-group">
              <label>Service Category</label>                        
              <multiselect v-model="category" label="name" :options="servicecategories"></multiselect>
            </div>
            <div class="form-group mb-2">
            <label>Service Name</label>
            <input v-model="name" type="text" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Cost price</label>
            <input v-model="costprice" type="text" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Service Price</label>
            <input v-model="serviceprice" type="text" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-service" centered title="Edit Service" title-class="font-14" hide-footer>
        <form @submit.prevent="editService">
            <input v-model="id" type="hidden">
            <div class="form-group">
              <label>Service Category</label>                        
              <b-form-select v-model="category" required :options="servicecategories" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
            </div>
            <div class="form-group mb-2">
            <label>Service Name</label>
            <input v-model="name" type="text" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Cost price</label>
            <input v-model="costprice" type="text" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Service Price</label>
            <input v-model="serviceprice" type="text" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-service')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-service" centered title="Delete Service" title-class="font-18" hide-footer>
        <form @submit.prevent="removeService">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Service : <b>{{ name }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-service')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>
 
  </Layout>
  

</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { serviceMethods, serviceComputed,serviceCategoryMethods,serviceCategoryComputed } from "@/state/helpers";

export default {
  page: {
    title: "Facilty Services",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader,Multiselect
  },
  data() {
    return {
      title: "Facilty Services",
      items: [ {text: "Dashboard",to: "/",}, {text: "Facilty Services",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'category', label: 'Category', visible: true },
          { key: 'name', label: 'Service Name', visible: true },
          { key: 'costprice', label: 'Cost Price', visible: true },
          { key: 'serviceprice', label: 'Service Price', visible: true },
          { key: 'addedby', label: 'Added by', visible: true },
          { key: 'addedon', label: 'Added on', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      name:'',
      category:'',
      costprice:'',
      serviceprice:'',
      serviceSystemKey:'',
      serviceIsSystem:0,
    };
  },
  computed: {
    ...serviceComputed,
    ...serviceCategoryComputed,
    List() { return this.services.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.services.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.services.length>0) { a=false;} else { a=true;} return a },
    totalCostprice() { return this.services.reduce((total, item) => total + Number(item.costprice), 0); },
    totalServiceprice() { return this.services.reduce((total, item) => total + Number(item.serviceprice), 0); },

  },
  mounted() {
    this.fetchServices();
    this.fetchServiceCategory();
    this.TotalRows = this.services.length;
    this.isBusy=false;
  },
  methods: {
    ...serviceMethods,
    ...serviceCategoryMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,category,name,costprice,serviceprice,systemKey,isSystem){
      this.id=id;
      this.category=category;
      this.name=name;
      this.costprice=costprice;
      this.serviceprice=serviceprice;
      this.serviceSystemKey=systemKey || '';
      this.serviceIsSystem=isSystem || 0;
      this.$bvModal.show('edit-service')
    },
    remove(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('delete-service')
    },
    async addService() { 
      let formData = new FormData();
      formData.append("category", this.category.id);
      formData.append("name", this.name);
      formData.append("costprice", this.costprice);
      formData.append("serviceprice", this.serviceprice);
      let url = "/addservice";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchServices();
          this.$bvModal.hide('new-service');
          this.category="";
          this.name="";
          this.costprice="";
          this.serviceprice="";
      }
      });
    },
    async editService(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("category", this.category);
    formData.append("name", this.name);
    formData.append("costprice", this.costprice);
    formData.append("serviceprice", this.serviceprice);
    let url = "/updateservice";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchServices();
        this.$bvModal.hide('edit-service');
        this.category="";
        this.name="";
        this.costprice="";
        this.serviceprice="";
        this.serviceSystemKey="";
        this.serviceIsSystem=0;
      }
    });
    },
    async removeService() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removeservice";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchServices();
        this.$bvModal.hide('delete-service');
      }
    });
    },
  },
};
</script>
<style scoped>
.horizontal-separator {
  margin: 0 15px; 
}
</style>
